<div class="activity-log--wrapper relative px-5">
  <ul class="timeline">
    <ng-container *ngFor="let activityLog of activityLogs; trackBy: trackByValue">
      <li class="event" [attr.data-date]="activityLog?.createdAt | date: 'medium'">
        <h3>{{ activityLog?.description }}</h3>
        <p
          >{{ activityLog?.causer?.firstName }}
          {{ activityLog?.causer?.lastName }}</p
        >
      </li>
    </ng-container>
  </ul>

  <div class="show-more-container text-center mt-4">
    <lum-ui-button
      *ngIf="pagination.current_page < pagination.last_page"
      [loading]="loading"
      (clickEvent)="onShowMore()"
    >
      Show More
    </lum-ui-button>
  </div>
</div>
